import React from 'react';
import cloneManager from '../services/cloneManager';
import './AppBrandingMark.css';

const GENERIC_TENANT_LABELS = new Set(['Clone', 'Connexion Manuelle']);

function getTenantSubtitle(previewTenantName) {
  if (previewTenantName != null && String(previewTenantName).trim() !== '') {
    const p = String(previewTenantName).trim();
    if (!GENERIC_TENANT_LABELS.has(p)) return p;
  }
  const stored = cloneManager.getClone();
  const s = (stored?.company_name || stored?.clone_name || '').trim();
  if (!s || GENERIC_TENANT_LABELS.has(s)) return null;
  return s;
}

export default function AppBrandingMark({
  theme = 'dark',
  previewTenantName = null,
  previewLogoUrl = null,
  className = '',
}) {
  const logoFromClone = cloneManager.getLogoUrl();
  const logoUrl = previewLogoUrl || logoFromClone || null;
  const subtitle = getTenantSubtitle(previewTenantName);

  return (
    <div className={`app-branding app-branding--${theme} ${className}`.trim()}>
      {logoUrl ? (
        <>
          <img
            src={logoUrl}
            alt={subtitle || 'Logo entreprise'}
            className="app-branding__logo"
            decoding="async"
          />
          {subtitle ? (
            <span className="app-branding__tenant">{subtitle}</span>
          ) : null}
        </>
      ) : (
        <>
          <span className="app-branding__product">RAPTECK</span>
          <span className="app-branding__tagline">
            {subtitle || 'Inspection mobile'}
          </span>
        </>
      )}
    </div>
  );
}
